import { Button } from '@corratech/pylot-ui'
import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'
import s from '@corratech/air-ooka-header/StoreSwitcher/StoreSwitcher.module.scss'
import { ClickOutside } from '@corratech/pylot-utils'
import { useState } from 'react'
import { StoreSwitcherPopup } from '@corratech/air-ooka-header/StoreSwitcher/StoreSwitcherPopup'
import { useStoreSwitcherConfig } from '@corratech/air-ooka-header/StoreSwitcher/use-StoreSwitcherConfig'
import cn from 'classnames'
import { useIsMobile } from '@components/common/IsMobile/useIsMobile'
const StoreSwitcher = () => {
    const router = useRouter()
    const { t } = useTranslation(['common'])
    const [displayStoreSwitcherPopup, setDisplayStoreSwitcherPopup] = useState(
        false
    )
    const allStores = useStoreSwitcherConfig()
    const isMobile = useIsMobile()

    return (
        <ClickOutside
            active={displayStoreSwitcherPopup}
            onClick={() => setDisplayStoreSwitcherPopup(false)}
        >
            <div className={cn(s.StoreSwitcher, 'headerStoreSwitcher')}>
                <Button
                    variant="link"
                    className={s.StoreSwitcherButton}
                    onClick={() =>
                        setDisplayStoreSwitcherPopup(!displayStoreSwitcherPopup)
                    }
                >
                    {
                        allStores?.find(
                            (store) =>
                                store.store ===
                                process.env.NEXT_PUBLIC_STORE_CODE
                        )?.flag
                    }
                    {!isMobile && (
                        <span className={s.StoreSwitcherText}>
                            {t(`localeNames|${router.locale}`)}
                        </span>
                    )}
                </Button>
                <StoreSwitcherPopup
                    closePopup={() => setDisplayStoreSwitcherPopup(false)}
                    displayStoreSwitcherPopup={displayStoreSwitcherPopup}
                    allStores={allStores}
                />
            </div>
        </ClickOutside>
    )
}

export default StoreSwitcher
